module.exports = __webpack_public_path__ + "static/img/thumb_6.8c54909.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_6.jpg
// module id = yiP3
// module chunks = 0